export default __webpack_public_path__ + "static/media/profileEditableNotice.9723047e.jpg";